<ng-container *ngIf="!editMode">
	<div
		class="bg-[#FCFCFC] lg:p-[46px] p-[26px] max-w-[981px] m-auto custom-shadow rounded-12px"
	>
		<div class="text-center mb-[36px]">
			<p class="text-medium-gray text-[12px]">
				{{ 'PRODUCT_PROMO.PRODUCT_PROMO' | translate }}
			</p>
			<p class="text-[#4E4B66] font-semibold leading-[26px] text-[24px]">
				{{ 'PRODUCT_PROMO.VIEW_PROMO_CODE' | translate }}
			</p>
		</div>

		<div class="flex flex-col">
			<!-- Activation State Start -->

			<div class="w-full h-[98px] rounded-[12px] bg-main-color-black">
				<div
					class="flex justify-between px-[24px] py-[28px] max-mobile:px-padding-mobile-14 max-mobile:py-padding-mobile-14"
				>
					<div class="flex flex-col my-auto max-mobile:text-font-mobile-small">
						<p class="text-gradient mb-1">
							{{ 'GENERAL_LABELS.STATUS' | translate }}
						</p>
						<p class="text-[#F5F5F5] mb-1 max-mobile:text-font-mobile-small">
							{{ 'PRODUCT_PROMO.ABILITY_TO' | translate }}
						</p>
					</div>

					<div class="flex">
						<span
							class="{{
								promocodeDetials?.isActive
									? ' text-[#00BA88] '
									: '  text-[#B3261E]  '
							}}mx-auto lg:mt-3 mt-5"
							>{{
								'STATUS.' + (promocodeDetials?.isActive ? 'ACTIVE' : 'INACTIVE')
									| translate
							}}</span
						>

						<div class="lg:w-[36px] m-auto mx-2">
							<mat-slide-toggle
								(change)="activateDeactivatePromocode($event)"
								[checked]="promocodeDetials?.isActive"
								hideIcon
							></mat-slide-toggle>
						</div>
					</div>
				</div>
			</div>

			<div class="mt-36px">
				<div class="py-[14px] flex justify-between items-center">
					<p class="mb-0 font-DIN-Medium text-font-16">
						{{ 'PRODUCT_PROMO.BASIC_INFO' | translate }}
					</p>
					<div
						class="flex cursor-pointer"
						*ngIf="promocodeDetials?.canEdit"
						(click)="changeEditMode(true)"
					>
						<img
							class="cursor-pointer"
							src="./assets/images/edit-blue.svg"
							alt=""
						/>
						<p class="cursor-pointer" class="text-blue-link m-0">
							{{ 'ACTIONS.EDIT' | translate }}
						</p>
					</div>
				</div>
				<div class="bg-off-white rounded-12px p-24px shadow">
					<!-- NAME EN AR -->
					<h1 class="text-font-14 font-DIN-Regular text-medium-gray mb-0">
						{{ 'PRODUCT_PROMO.NAME_EN' | translate }}
					</h1>
					<p class="text-font-16 font-DIN-Regular text-dark-grey break-all">
						{{ promocodeDetials?.offerNameEn }}
					</p>
					<div class="h-[1px] w-full bg-secondry-color-Gray my-8px"></div>
					<h1 class="text-font-14 font-DIN-Regular text-medium-gray mb-0">
						{{ 'PRODUCT_PROMO.NAME_AR' | translate }}
					</h1>
					<p class="text-font-16 font-DIN-Regular text-dark-grey break-all">
						{{ promocodeDetials?.offerNameAr }}
					</p>
					<!-- NAME EN AR -->
					<div class="h-[1px] w-full bg-secondry-color-Gray my-8px"></div>
					<!-- promo code  name -->
					<h1 class="text-font-14 font-DIN-Regular text-medium-gray mb-0">
						{{ 'PRODUCT_PROMO.PROMO_CODE' | translate }}
					</h1>
					<p class="text-font-16 font-DIN-Regular text-dark-grey break-all">
						{{ promocodeDetials?.code }}
					</p>

					<div class="flex justify-evenly">
						<div>
							<img
								class="w-[200px]"
								[src]="attachmentLink + promocodeDetials.offerImageEn"
								alt=""
							/>
							<h1 class="text-font-14 text-dark-grey">
								{{ 'ACTIONS.UPLOAD_IMG_EN' | translate }}
							</h1>
						</div>
						<div>
							<img
								class="w-[200px]"
								[src]="attachmentLink + promocodeDetials.offerImageAr"
								alt=""
							/>
							<h1 class="text-font-14 text-dark-grey">
								{{ 'ACTIONS.UPLOAD_IMG_AR' | translate }}
							</h1>
						</div>
					</div>
					<div class="h-[1px] w-full bg-secondry-color-Gray my-8px"></div>
					<!-- promo code  name -->
					<!-- MAX CLIENT USAGE  -->
					<h1 class="text-font-14 font-DIN-Regular text-medium-gray mb-0">
						{{ 'PRODUCT_PROMO.MAX_CLIENT_USE' | translate }}
					</h1>
					<p class="text-font-16 font-DIN-Regular text-dark-grey">
						{{ promocodeDetials?.clientUsageCount }}
					</p>
					<!-- MAX CLIENT USAGE  -->
					<div class="h-[1px] w-full bg-secondry-color-Gray my-8px"></div>
					<!-- MAX USAGE  -->
					<h1 class="text-font-14 font-DIN-Regular text-medium-gray mb-0">
						{{ 'PRODUCT_PROMO.MAX_NO_USAGE' | translate }}
					</h1>
					<p class="text-font-16 font-DIN-Regular text-dark-grey">
						{{ promocodeDetials?.maxUsageCount }}
					</p>
					<!-- MAX USAGE  -->
					<div class="h-[1px] w-full bg-secondry-color-Gray my-8px"></div>
					<!-- duration -->
					<div>
						<p class="text-font-14 font-DIN-Medium text-medium-gray mb-0">
							{{ 'PRODUCT_PROMO.DURATION' | translate }}
						</p>
						<div class="flex flex-wrap w-full py-2 items-start">
							<p class="text-font-16 text-dark-grey font-DIN-Regular">
								{{ promocodeDetials?.startDate | date : 'd/M/yy' }}
							</p>

							<p
								class="text-[#4E4B66] text-center mx-[5px] max-mobile:w-[100%]"
							>
								{{ 'GENERAL.TO' | translate }}
							</p>
							<p class="text-font-16 text-dark-grey font-DIN-Regular">
								{{ promocodeDetials?.endDate | date : 'd/M/yy' }}
							</p>
							<!-- duration -->
						</div>

						<!-- HAS LABEL  -->
						<mat-checkbox
							*ngIf="promocodeDetials?.hasLabel"
							[checked]="promocodeDetials?.hasLabel"
							[disabled]="true"
							class="my-12px"
							>{{ 'PRODUCT_PROMO.SHOW_LABEL' | translate }}</mat-checkbox
						>
						<!-- HAS LABEL  -->
					</div>
				</div>
				<h1 class="mt-36px text-font-16 font-DIN-Medium">
					{{ 'PRODUCT_PROMO.PRODUCT_FILTER' | translate }}
				</h1>
				<div class="bg-off-white rounded-12px p-24px shadow">
					<!-- COUNTRY  -->
					<p class="text-font-16 font-DIN-Regular text-dark-grey">
						{{ 'GENERAL_LABELS.COUNTRY' | translate }}
					</p>
					<div class="flex justify-between w-[65%]">
						<mat-radio-button
							class="ltr:mr-[24px] rtl:ml-[24px] text-font-14 text-dark-grey opacity-25 pointer-events-none"
							[checked]="promocodeDetials?.countryId == 224"
							>{{ 'COUNTRIES.EGYPT' | translate }}</mat-radio-button
						>
						<mat-radio-button
							[checked]="promocodeDetials?.countryId == 103"
							class="text-font-14 text-dark-grey opacity-25 pointer-events-none"
							>{{ 'COUNTRIES.SAUDI_ARABIA' | translate }}</mat-radio-button
						>
					</div>
					<!-- COUNTRY  -->
					<!-- GENDER -->
					<div>
						<p
							*ngIf="promocodeDetials?.gender?.length"
							class="text-font-16 text-dark-grey font-DIN-Medium"
						>
							{{ 'PRODUCT_PROMO.GENDER' | translate }}
						</p>

						<div class="flex justify-between w-[59%]">
							<ng-container *ngFor="let gender of genders">
								<mat-checkbox
									*ngIf="
										promocodeDetials?.gender
											? promocodeDetials.gender.includes(gender?.value)
											: null
									"
									[disabled]="true"
									[checked]="
										promocodeDetials?.gender
											? promocodeDetials.gender.includes(gender?.value)
											: null
									"
									[value]="gender.value"
									>{{
										'GENERAL_LABELS.' + gender.name.toUpperCase() | translate
									}}</mat-checkbox
								>
							</ng-container>
						</div>
					</div>
					<!-- GENDER -->
					<!-- CATEGORY  -->
					<div>
						<h1
							*ngIf="promocodeDetials?.category"
							class="text-font-12 text-dark-grey font-DIN-Regular mb-0"
						>
							{{ 'STORE.ADD_PRODUCT.CATEGORY' | translate }}
						</h1>
						<p class="text-font-16 text-medium-gray font-DIN-Regular">
							{{
								translate.currentLang == 'en'
									? promocodeDetials?.category?.name?.en
									: promocodeDetials?.category?.name?.ar
							}}
						</p>
						<ng-container *ngIf="promocodeDetials?.subCategory">
							<div class="h-[1px] w-full bg-secondry-color-Gray my-8px"></div>
							<h1 class="text-font-12 text-dark-grey font-DIN-Regular mb-0">
								{{ 'STORE.ADD_PRODUCT.SUB_CATEGORY' | translate }}
							</h1>
							<p class="text-font-16 text-medium-gray font-DIN-Regular">
								{{
									translate.currentLang == 'en'
										? promocodeDetials?.subCategory?.name?.en
										: promocodeDetials?.subCategory?.name?.ar
								}}
							</p>
						</ng-container>
						<ng-container *ngIf="promocodeDetials?.subSubCategory">
							<div class="h-[1px] w-full bg-secondry-color-Gray my-8px"></div>
							<h1 class="text-font-12 text-dark-grey font-DIN-Regular mb-0">
								{{ 'STORE.ADD_PRODUCT.SUB_SUB_CATEGORY' | translate }}
							</h1>
							<p class="text-font-16 text-medium-gray font-DIN-Regular">
								{{
									translate.currentLang == 'en'
										? promocodeDetials?.subSubCategory?.name?.en
										: promocodeDetials?.subSubCategory?.name?.ar
								}}
							</p>
						</ng-container>
						<ng-container *ngIf="promocodeDetials?.brand">
							<div class="h-[1px] w-full bg-secondry-color-Gray my-8px"></div>
							<h1 class="text-font-12 text-dark-grey font-DIN-Regular mb-0">
								{{ 'STORE.ADD_PRODUCT.BRAND' | translate }}
							</h1>
							<p class="text-font-16 text-medium-gray font-DIN-Regular">
								{{
									translate.currentLang == 'en'
										? promocodeDetials?.brand?.name?.en
										: promocodeDetials?.brand?.name?.ar
								}}
							</p>
						</ng-container>

						<ng-container
							*ngIf="
								promocodeDetials?.productName
									? promocodeDetials.productName.length > 0
									: null
							"
						>
							<h1 class="text-font-12 text-dark-grey font-DIN-Regular mb-0">
								{{ 'PRODUCT_PROMO.PRODUCTS' | translate }}
							</h1>
							<div
								class="flex flex-wrap max-w-[80%] max-h-[250px] overflow-auto"
							>
								<div
									*ngFor="let product of promocodeDetials.productName"
									class="p-3 rounded-[50px] bg-gradient text-off-white mb-3 mx-1"
								>
									<p class="mb-0 whitespace-nowrap">
										{{
											translate.currentLang == 'en'
												? product?.name.en
												: product?.name?.ar
										}}
									</p>
								</div>
							</div>
						</ng-container>
						<ng-container *ngIf="promocodeDetials?.numberOfSameProduct">
							<div class="h-[1px] w-full bg-secondry-color-Gray my-8px"></div>
							<h1 class="text-font-12 text-dark-grey font-DIN-Regular mb-0">
								{{ 'PRODUCT_PROMO.SAME_PRODUCT' | translate }}
							</h1>
							<p class="text-font-16 text-medium-gray font-DIN-Regular">
								{{ promocodeDetials?.numberOfSameProduct }}
							</p>
						</ng-container>
					</div>
					<!-- CATEGORY  -->
				</div>
				<h1 class="mt-36px text-font-16 font-DIN-Medium">
					{{ 'PRODUCT_PROMO.PRICE' | translate }}
				</h1>
				<div class="bg-off-white rounded-12px p-24px shadow">
					<!-- TYPE  -->
					<h1 class="text-font-14 text-medium-gray font-DIN-Regular mb-0">
						{{ 'PRODUCT_PROMO.OFFER_TYPE' | translate }}
					</h1>
					<p class="text-font-16 text-dark-grey font-DIN-Regular">
						<!-- TYPE  -->
						<span *ngIf="promocodeDetials?.promoCodeType == 1">{{
							'PRODUCT_PROMO.FIXED_VALUE' | translate
						}}</span>
						<span *ngIf="promocodeDetials?.promoCodeType == 2">{{
							'PRODUCT_PROMO.PERCENTAGE' | translate
						}}</span>
						<span *ngIf="promocodeDetials?.promoCodeType == 3">{{
							'PRODUCT_PROMO.OFFER' | translate
						}}</span>
					</p>
					<div class="h-[1px] w-full bg-secondry-color-Gray my-8px"></div>

					<ng-container *ngIf="promocodeDetials?.promoCodeType == 1">
						<h1 class="text-font-14 text-medium-gray font-DIN-Regular mb-0">
							{{ 'PRODUCT_PROMO.OFFER_AMOUNT' | translate }}
						</h1>
						<p class="text-font-16 text-dark-grey font-DIN-Regular">
							<!-- TYPE  -->
							{{ promocodeDetials?.promoCodeAmount }}
						</p>
						<div class="h-[1px] w-full bg-secondry-color-Gray my-8px"></div>
						<h1 class="text-font-14 text-medium-gray font-DIN-Regular mb-0">
							{{ 'PRODUCT_PROMO.MINUMUM_CHECKOUT_PRICE' | translate }}
						</h1>
						<p class="text-font-16 text-dark-grey font-DIN-Regular">
							<!-- TYPE  -->
							{{ promocodeDetials?.fixedDiscountMinimum }}
						</p>
					</ng-container>
					<ng-container *ngIf="promocodeDetials?.promoCodeType === 2">
						<h1 class="text-font-14 text-medium-gray font-DIN-Regular mb-0">
							{{ 'PRODUCT_PROMO.OFFER_AMOUNT' | translate }}
						</h1>
						<p class="text-font-16 text-dark-grey font-DIN-Regular">
							{{ promocodeDetials?.promoCodeAmount }} %
						</p>
						<div class="h-[1px] w-full bg-secondry-color-Gray my-8px"></div>
						<h1 class="text-font-14 text-medium-gray font-DIN-Regular mb-0">
							{{ 'PRODUCT_PROMO.UPTO' | translate }}
						</h1>
						<p class="text-font-16 text-dark-grey font-DIN-Regular">
							{{ promocodeDetials?.percentageUpto }}
						</p>
					</ng-container>
					<ng-container *ngIf="promocodeDetials?.promoCodeType === 3">
						<h1 class="text-font-14 text-medium-gray font-DIN-Regular mb-0">
							{{ 'PRODUCT_PROMO.BUY_NUM' | translate }}
						</h1>
						<p class="text-font-16 text-dark-grey font-DIN-Regular">
							{{ promocodeDetials?.offerBuyCount }}
						</p>
						<div class="h-[1px] w-full bg-secondry-color-Gray my-8px"></div>
						<h1 class="text-font-14 text-medium-gray font-DIN-Regular mb-0">
							{{ 'PRODUCT_PROMO.GET_NUM' | translate }}
						</h1>
						<p class="text-font-16 text-dark-grey font-DIN-Regular">
							{{ promocodeDetials?.offerGetCount }}
						</p>
					</ng-container>
				</div>
			</div>
		</div>
		<button
			(click)="deletePromocode()"
			class="w-full bg-off-white border-[1px] border-secondry-color-Gray rounded-6px text-red-error py-16px mt-36px"
		>
			{{ 'ACTIONS.DELETE' | translate }}
		</button>
	</div>
</ng-container>
<ng-container *ngIf="editMode">
	<app-edit-product-promocode
		[promocodeDetails]="promocodeDetials"
		[id]="this.id"
		(changeEditMode)="changeEditMode($event); getPromocodeDetails()"
	></app-edit-product-promocode>
</ng-container>
